import { Component, OnInit, ViewEncapsulation, Input } from '@angular/core';
import { OvsComponent } from '../../shared/core/ovs.core';
import { ResortDetail, ResortInventory, ResortAmenity, ResortImage } from '../../models/presentation.model';
import { ResortInventoryGroup } from '../../models/browser.model';
import { ResortApplicationBase } from '../../services/resort-application.service';
import { ResortComponent } from '../../shared/resort.component';
import { MatDialog, MatDialogRef } from '@angular/material';
import { RoomAvailabilityComponent } from '../room-availability/room-availability.component';
import { SafeResourceUrl } from "@angular/platform-browser";
import { UpdateClientService } from '../../services/update-client.service';

@Component({
    selector: 'resort-availability',
    templateUrl: './resort-availability.component.html',
    styleUrls: ['./resort-availability.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class ResortAvailabilityComponent extends ResortComponent
{
    private _dialog: MatDialog;
    private _roomDialog: MatDialogRef<RoomAvailabilityComponent, ResortInventory>;

	@Input()
	public group: ResortInventoryGroup;
	@Input()
	public index: number;
    public amenities: string[] = [];

    public get hasDiscount(): boolean{
        return this.group && this.group.featuredInventory && this.group.featuredInventory.hasDiscount;
    }

    public get memberRate(): number{
        return this.group && this.group.featuredInventory && this.group.featuredInventory.getMemberRate(this.configuration.ShowPricePerDay);
    }

    constructor(dialog: MatDialog, private updateClientService: UpdateClientService)
    {
        super();
        this._dialog = dialog;
        this.listenForChange(() => this.group, (o, n) => this.onGroupChanged());
    }

    protected initialize(): void
    {
        super.initialize();
    }

    private onGroupChanged(): void
    {
        if (this.group)
        {
            let amenities: ResortAmenity[] = [];
            amenities.addRange(this.group.resort.onSiteAmenityList);
            amenities.addRange(this.group.resort.offSiteAmenityList);
            amenities.addRange(this.group.resort.unitAmenityList);
            this.amenities = amenities.select(a => a.Name).toArray();
        }
    }

    public book(inventory: ResortInventory): void
    {
        this.updateClientService.EnsureLatestVersion(() => {
            this.application.checkOut(this.group.resort, inventory);
        });
    }

    public showCompleteAvailability(): void
    {
        this._roomDialog = this._dialog.open(RoomAvailabilityComponent, { data: this.group });
        this._roomDialog.afterClosed().subscribe(inventory =>
        {
            if (inventory)
                this.book(inventory);
        });

        this.updateClientService.EnsureLatestVersion(null);
    }

}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/Ovs.Resort.UI.Web/src/app/resort-detail/resort-availability/resort-availability.component.ts